module.exports = __webpack_public_path__ + "static/media/presentacion-kanechom.12b08baa.png";